module.exports = __webpack_public_path__ + "img/remediation.90996b72.svg";